import { render, staticRenderFns } from "./EditForm.vue?vue&type=template&id=fb6f80f2&scoped=true&"
import script from "./EditForm.vue?vue&type=script&lang=js&"
export * from "./EditForm.vue?vue&type=script&lang=js&"
import style0 from "./EditForm.vue?vue&type=style&index=0&id=fb6f80f2&lang=scss&scoped=true&"
import style1 from "./EditForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6f80f2",
  null
  
)

export default component.exports